import { render, staticRenderFns } from "./PesquisaMotivacaoProjeto.vue?vue&type=template&id=22e75586&scoped=true"
import script from "./PesquisaMotivacaoProjeto.vue?vue&type=script&lang=js"
export * from "./PesquisaMotivacaoProjeto.vue?vue&type=script&lang=js"
import style0 from "./PesquisaMotivacaoProjeto.vue?vue&type=style&index=0&id=22e75586&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22e75586",
  null
  
)

export default component.exports